import {Locale} from './Locale';
import {StorageUtility} from './Storage';

declare var window: any;
declare var accounting: any;
declare var $: any;

export class Pricing {
    private static instance: Pricing;

    static getInstance(): Pricing {
        if (!Pricing.instance) {
            Pricing.instance = new Pricing();
        }
        return Pricing.instance;
    }

    public currencies = require('./../data/currencies.json');

    private currencyFormatter = {
        en_US: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '$',
            prepend: true,
            code: 'USD',
        },
        ja_JP: {
            decPlaces: 0,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '￥',
            prepend: true,
            code: 'JPY',
        },
        es_ES: {
            decPlaces: 2,
            thouSeparator: '.',
            decSeparator: ',',
            symbol: 'USD',
            prepend: false,
            code: 'USD',
        },
        pt_BR: {
            decPlaces: 2,
            thouSeparator: '.',
            decSeparator: ',',
            symbol: 'US$',
            prepend: true,
            code: 'USD',
        },
        de_DE: {
            decPlaces: 2,
            thouSeparator: '.',
            decSeparator: ',',
            symbol: '€',
            prepend: false,
            code: 'EUR',
        },
        ru_RU: {
            decPlaces: 2,
            thouSeparator: ' ',
            decSeparator: ',',
            symbol: 'USD',
            prepend: false,
            code: 'USD',
        },
        pl_PL: {
            decPlaces: 2,
            thouSeparator: ' ',
            decSeparator: ',',
            symbol: 'USD',
            prepend: false,
            code: 'USD',
        },
        en_GB: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '£',
            prepend: true,
            code: 'GBP',
        },
        it_IT: {
            decPlaces: 2,
            thouSeparator: '.',
            decSeparator: ',',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        fr_FR: {
            decPlaces: 2,
            thouSeparator: ' ',
            decSeparator: ',',
            symbol: '€',
            prepend: false,
            code: 'EUR',
        },
        zh_CN: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: 'USD',
            prepend: true,
            code: 'USD',
        },
        ar_AE: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: 'USD',
            prepend: true,
            code: 'USD',
        },
        nl_NL: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
    };

    private currencyFormatterEU = {
        en_US: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        ja_JP: {
            decPlaces: 0,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '￥',
            prepend: true,
            code: 'JPY',
        },
        es_ES: {
            decPlaces: 2,
            thouSeparator: '.',
            decSeparator: ',',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        pt_BR: {
            decPlaces: 2,
            thouSeparator: '.',
            decSeparator: ',',
            symbol: 'US$',
            prepend: true,
            code: 'USD',
        },
        de_DE: {
            decPlaces: 2,
            thouSeparator: '.',
            decSeparator: ',',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        ru_RU: {
            decPlaces: 2,
            thouSeparator: ' ',
            decSeparator: ',',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        pl_PL: {
            decPlaces: 2,
            thouSeparator: ' ',
            decSeparator: ',',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        en_GB: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '£',
            prepend: true,
            code: 'GBP',
        },
        it_IT: {
            decPlaces: 2,
            thouSeparator: '.',
            decSeparator: ',',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        fr_FR: {
            decPlaces: 2,
            thouSeparator: ' ',
            decSeparator: ',',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        zh_CN: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        ar_AE: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
        nl_NL: {
            decPlaces: 2,
            thouSeparator: ',',
            decSeparator: '.',
            symbol: '€',
            prepend: true,
            code: 'EUR',
        },
    };

    public constructor() {
        this.setCurrency = this.setCurrency.bind(this);
    }

    public formatCurrency(n, dropCents, region) {
        let currentLocale = Locale.getInstance().getCurrentLocale();

        if (n < 0) {
            n = 0;
        }
        let formatOptions;
        if (!region || region === 'us') {
            formatOptions = this.currencyFormatter[currentLocale];
        } else {
            formatOptions = this.currencyFormatterEU[currentLocale];
        }
        const symbol = formatOptions.symbol;
        const precision = dropCents ? 0 : formatOptions.decPlaces;
        const thousand = formatOptions.thouSeparator;
        const format = formatOptions.prepend ? '%s%v' : '%v%s';
        return accounting.formatMoney(n, {symbol, precision, thousand, format});
    }

    /**
     * @summary Sets the data-currency attribute on the page body.
     * @since 16.15.35
     */
    public setCurrency(data) {
        try {
            let prevCurrency = StorageUtility.getInstance().getSession('currency_code');

            if (data?.currency?.code && this.currencies[data.currency.code]) {
                document.body.dataset.currency = data.currency.code;
                document.body.dataset.currencySymbol = this.currencies[data.currency.code].symbol;
                StorageUtility.getInstance().setSession('currency_code', data.currency.code);

                if (prevCurrency !== data.currency.code) {
                    const event = new CustomEvent('currency_change', {
                        detail: {
                            currencyCode: data.currency.code,
                        },
                    });
                    window.dispatchEvent(event);
                }
            }
        } catch (e) {
            console.warn(e);
        }
    }

    /**
     * @summary Gets the currency code from the session.
     * @since 16.19.4
     */
    public getCurrency() {
        const currencyCountryMap = require('./../data/country-code-to-currency.json');
        const countryCode = Locale.getInstance().getCurrentCountry();

        try {
            // First check body data attribute (set by setCurrency, works without consent)
            const bodyDataCurrency = document.body.dataset.currency;
            if (bodyDataCurrency) {
                return bodyDataCurrency;
            }

            return (
                StorageUtility.getInstance().getSession('currency_code') ||
                (currencyCountryMap && currencyCountryMap[countryCode]
                    ? currencyCountryMap[countryCode]
                    : 'USD')
            );
        } catch (e) {
            console.warn(e);
        }
    }

    /**
     * @summary Returns the pricing data for all Keeper products.
     * @param {function} callback - The function to be called on completion.
     * @since 12.0.0
     * @returns {object} JSON object with pricing data.
     */
    public getProductPricingData = (promo, callback, localeOverride) => {
        let self = this;
        let locale = Locale.getInstance();

        function getProductPrices() {
            // If IP in Australia and locale not overridden, set to en_AU
            if (
                localeOverride == null &&
                (locale.isOriginalKeeperRegion('AU') || locale.hasDataRegionParam('au'))
            ) {
                localeOverride = 'en_AU';
            }
            // If IP in Japan and locale not overridden, set to ja_JP
            if (
                localeOverride == null &&
                (locale.isOriginalKeeperRegion('JP') || locale.hasDataRegionParam('jp'))
            ) {
                localeOverride = 'ja_JP';
            }

            // If IP in Canada and locale not overridden, set to en_CA
            if (
                localeOverride == null &&
                (locale.isOriginalKeeperRegion('CA') || locale.hasDataRegionParam('ca'))
            ) {
                localeOverride = 'en_CA';
            }

            const parameters = {
                ipCountry: localeOverride ? '' : locale.getCurrentCountry() || '',
                locale: localeOverride || locale.getCurrentLocale(),
                promoCode: promo || '',
            };

            const config = {
                success: [
                    data => {
                        self.setCurrency(data);

                        // Store in StorageUtility (respects consent)
                        StorageUtility.getInstance().setSession(
                            'product_pricing_data',
                            JSON.stringify(data)
                        );

                        // Also store directly in sessionStorage to ensure availability without consent
                        // This matches what some business pages do (e.g., business-add-ons)
                        if (typeof sessionStorage !== 'undefined') {
                            try {
                                sessionStorage.setItem(
                                    'product_pricing_data',
                                    JSON.stringify(data)
                                );
                            } catch (e) {
                                console.warn('Failed to store pricing data in sessionStorage:', e);
                            }
                        }

                        const event = new CustomEvent('pricing_updated');
                        window.dispatchEvent(event);
                    },
                    callback,
                ],
            };

            window.keeper.servlets.keeperWeb.checkoutApiWeb(
                'get_product_prices',
                parameters,
                config
            );
        }

        // wait for region call to finish up before getting product prices
        if (window.regionDetected === true) {
            getProductPrices();
        } else {
            document.addEventListener('region_detected', function () {
                getProductPrices();
            });
        }
    };

    /**
     * @summary Gets and parses the pricing data for all Keeper products from session storage.
     * @since 16.18.22
     */

    public getProductPricingDataFromSession = (promo, callback, localeOverride) => {
        let self = this;

        // If localeOverride is provided, we want fresh data for that specific locale/currency
        // so bypass cached data and force an API call
        let sessionPrices = null;

        if (!localeOverride) {
            // Only use cached data if no locale override is specified

            // Try StorageUtility first (respects consent)
            sessionPrices = JSON.parse(
                StorageUtility.getInstance().getSession('product_pricing_data') || null
            );

            // If StorageUtility returns null but sessionStorage has data (no consent case),
            // access sessionStorage directly like some business pages do
            if (!sessionPrices && typeof sessionStorage !== 'undefined') {
                try {
                    sessionPrices = JSON.parse(
                        sessionStorage.getItem('product_pricing_data') || null
                    );
                } catch (e) {
                    // If parsing fails, sessionPrices remains null
                    console.warn('Failed to parse pricing data from sessionStorage:', e);
                }
            }
        }

        return new Promise((resolve, reject) => {
            if (sessionPrices) {
                try {
                    if (callback instanceof Function) callback(sessionPrices);
                    self.setCurrency(sessionPrices);
                } catch (e) {
                    console.warn(e);
                }
                resolve(sessionPrices);
            } else {
                window.keeper.getProductPricingData(
                    promo,
                    [
                        callback,
                        function (data) {
                            if (data && data.error) {
                                console.error('Error: The pricing API failed. ' + data.error);
                                reject('Error: The pricing API failed. ' + data.error);
                                return;
                            }
                            resolve(data);
                        },
                    ],
                    localeOverride
                );
            }
        });
        //}
    };

    /**
     * @summary Returns the pricing data for all Keeper products.
     * @param {function} callback - The function to be called on completion.
     * @since 12.0.0
     * @returns {object} JSON object with pricing data.
     */
    public getReferralRewardData = (callback: Function, error: Function) => {
        window.keeper.servlets.keeperWeb.rewardApiWeb({
            success: callback,
            error,
        });
    };

    /**
     * @summary Returns the localized price within a string template.
     * @param {float} price - The unformatted price to format.
     * @param {integer} precision - The number of digits to show after the decimal.
     * @param {string} template - The string template to run replacements on.
     * @param {string} [currencyCode=this.getCurrency()] - The currency to use in the formatted price.
     * @since 12.0.0
     * @returns {string} Template string with localized price.
     */
    public formatPriceForDisplay = (
        price: any,
        precision,
        template,
        currencyCode = this.getCurrency()
    ) => {
        let locale = Locale.getInstance();
        if (locale.getCurrentLocale() === 'ja_JP' || currencyCode === 'JPY') {
            precision = 0;
        }

        // If currencyCode not overridden, set to regional currency.
        if (currencyCode == null) {
            if (locale.isOriginalKeeperRegion('AU') || locale.hasDataRegionParam('au')) {
                currencyCode = 'AUD';
                precision = 2;
                price = price * 1.1; // Include 10% GST for AU prices
            }
            // else if (this.isOriginalKeeperRegion('CA') || this.hasDataRegionParam('ca'))) {
            //     currencyCode = "CAD";
            // }
            else if (locale.isOriginalKeeperRegion('JP') || locale.hasDataRegionParam('jp')) {
                currencyCode = 'JPY';
                precision = 0;
            }
        } else if (currencyCode === 'AUD') {
            precision = 2;
            price = price * 1.1; // Include 10% GST for AU prices
        } else if (currencyCode === 'JPY') {
            precision = 0;
        }

        // Safety check for accounting library
        if (typeof accounting === 'undefined') {
            console.warn('Accounting library not available yet. Using fallback formatting');
            price = parseFloat(price).toFixed(precision || 2);
        } else {
            price = accounting.formatMoney(price, {
                symbol: '',
                precision,
            });
        }

        // if price ends in two zeros
        if (price[price.length - 1] === '0' && price[price.length - 2] === '0') {
            // if price is not single digit whole number
            if (price[1] !== '.') {
                // remove two zeros

                // Safety check for accounting library
                if (typeof accounting === 'undefined') {
                    price = parseFloat(price).toFixed(0);
                } else {
                    price = accounting.formatMoney(price, {
                        symbol: '',
                        precision: 0,
                    });
                }
            }
        }

        const dollars = price.split('.')[0];
        let cents = price.split('.')[1];
        if (!cents || cents === 0) {
            cents = '';
        }
        let symbol;
        let currency;
        let currencies = this.currencies;
        if (currencyCode === null) {
            symbol = $('body').data('currency-symbol');
            currency = $('body').data('currency');
        } else {
            symbol = currencies[currencyCode].symbol;
            currency = currencies[currencyCode].code;
        }

        template = template
            .replace('XXX,YYY', price.replace(',', '_').replace('.', ',').replace('_', '.')) // euros
            .replace('XXX.YYY', price)
            .replace('XXX', dollars)
            .replace('YYY', cents)
            .replace('SSS', symbol)
            .replace('CCC', currency)
            .replace('ZZZ', currency + symbol);

        return template;
    };
}

export default Pricing;
